/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Header from "./header/header"
import Hero from "./hero/hero"
import "./layout.css"
import Calendar from "./calendar/calendar"
import Guest from "./guest/guest"
import Icons from "./icons/icons"
import Icon from "./icon/icon"
import Footer from "./footer/footer"
import MobileForm from "./mobileForm/mobileForm"

const Layout = ({
  children,
  BackgroundImage,
  Title,
  webinarSubtitle,
  webinarDate,
  display,
  webinarTime,
  formId,
  guestImage,
  webinarIcons,
  guestParagraph,
  guestTitle,
  isRecording,
  sfFormId,
  Recording,
  isBefore,
  formWebinarTime,
  formWebinarKey,
  formPardotProgrammeCode,
  formGuestName
}) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

let registerTitle = "Register For Webinar"
let recordingTitle = "Access Webinar Recording"


  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} />
      <Hero
        webinarTitle={Recording ? recordingTitle : registerTitle }
        webinarSubtitle={webinarSubtitle}
        BackgroundImage={BackgroundImage}
        formId={formId}
        formWebinarTime={formWebinarTime}
        formPardotProgrammeCode={formPardotProgrammeCode}
        formWebinarKey={formWebinarKey}
        formGuestName={formGuestName}
      />
      <Calendar
      display={Recording ? {display : 'none'} : {display : 'block'}}
      webinarDate={webinarDate}
      webinarTime={webinarTime}
      />
      <MobileForm 
      formId={formId}
      formWebinarTime={formWebinarTime}
      formPardotProgrammeCode={formPardotProgrammeCode}
      formWebinarKey={formWebinarKey}
      formGuestName={formGuestName} 
      />
      <Guest
        guestImage={guestImage}
        guestParagraph={guestParagraph} 
        guestTitle={guestTitle}
      />
      <Icons>
        {webinarIcons.map(webinarIcon => (
          
          <Icon
            Icon={webinarIcon.Image.childImageSharp.fluid}
            Subtitle={webinarIcon.Subtitle}
          />
        ))}
      </Icons>

      <Footer />
    </>
  )
}

export default Layout
